/**
 * Car Services Index
 * Araç servislerini tek noktadan dışa aktarmak için barrel export dosyası.
 */

import { carBasicService } from './basic';
import { carHomeService } from './home';
import { carSearchService } from './search';
import { carSalesService } from './sales';
import { carFindeksService } from './findeks';
import { carCityService } from './city';
import { carDistrictService } from './district';
import { carAirportService } from './airport';
import { carCompanyService } from './company';


// Bireysel servis export'ları (tree-shaking ve selektif import için)
export { carBasicService };
export { carHomeService };
export { carSearchService };
export { carSalesService };
export { carFindeksService };
export { carCityService };
export { carDistrictService };
export { carAirportService };
export { carCompanyService };

/**
 * Tüm araç servislerini tek bir nesne altında toplayıp export eder.
 * Bu sayede `carServices.home.getPopularLocations()` şeklinde kullanım sağlanır.
 */
export const carServices = {
  basic: carBasicService,
  home: carHomeService,
  search: carSearchService,
  sales: carSalesService,
  findeks: carFindeksService,
  city: carCityService,
  district: carDistrictService,
  airport: carAirportService,
  company: carCompanyService,
};

export default carServices;


